import { useEffect, useMemo, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
import { tsParticles } from "@tsparticles/engine"

function Background(props) {
  let optionsPath = './js/particles/particles_light.json';
  const [init, setInit] = useState(false);
  const particlesLoaded = (container) => {
    console.log(container);
  };
  const options = useMemo(() => ({
      background: {
        color: {
          value: props.isDark? "#0f2632":"#c2e2ee",
        },
      },
      fpsLimit: 120,
      interactivity: {
        events: {
          onClick: {
            enable: true,
            mode: "push",
          },
          onHover: {
            enable: true,
            mode: "repulse",
          },
        },
        modes: {
          push: {
            quantity: 5,
          },
          repulse: {
            distance: 100,
            duration: 0.4,
          },
        },
      },
      particles: {
        color: {
          value: props.isDark? "#e7c6ee":"#4d224f",
        },
        links: {
          color: props.isDark? "#e7c6ee":"#4d224f",
          distance: 150,
          enable: props.isDark? false:true,
          opacity: 0.7,
          width: 1,
        },
        move: {
          direction: "none",
          enable: true,
          outModes: {
            default: "bounce",
          },
          random: false,
          speed: props.isDark? 0.5: 1.5,
          straight: false,
        },
        number: {
          density: {
            enable: false,
          },
          value: props.isDark? 64:90,
        },
        opacity: {
          value: {min:0.5,max:0.9},
        },
        shape: {
          type: props.isDark? "star":"circle",
        },
        size: {
          value: { min: 2, max: 4 },
        },
      },
      detectRetina: true,
    }),
    [props],
  );
  useEffect(() => {
    initParticlesEngine(async (engine) => {
      // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
      // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
      // starting from v2 you can add only the features you need reducing the bundle size
      //await loadAll(engine);
      //await loadFull(engine);
      await loadSlim(engine);
      //await loadBasic(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);
  // useEffect(()=>{
  //   optionsPath = props.isDark? './js/particles/particles_dark.json' : './js/particles/particles_light.json'
  //   tsParticles.load('particles-js', './js/particles/options.json', function() {
  //     console.log('callback - particles.js config loaded');
  //   });
  //   // window.particlesJS.load('particles-js', optionsPath, function() {
  //   //   console.log('callback - particles.js config loaded');
  //   // });
  // },[props])
  if (init) {
    return (
      <Particles
        id="tsparticles"
        particlesLoaded={particlesLoaded}
        options={options}
      />
    );
  }
  return (<></>); 
 }
 export default Background;